import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { HubService } from '../services/hub.service';
import { CustomerType } from '../types/customer-type';
import { Hub } from '../types/hub';
import { HubState } from '../types/hub-state';
import { HubHealth } from '../types/hubhealth';


@Component({
  selector: 'hub-state',
  templateUrl: './hub-state.component.html',
  styleUrls: ['./hub-state.component.css'],
  providers: [HubService],
})

export class HubStateComponent implements OnInit, OnChanges {
  @Input() inHub: Hub;
  hub: Hub;
  hubState: HubState;
  health: HubHealth[];
  customer_types = <CustomerType[]>[];
  errorMessage: string;
  heatingStateDescription: string;
  editable = false;
  upgradeVersion: string;

  constructor(
    private api: ApiService,
    private hubService: HubService,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

    try {
      this.hubService.getLookupTable('customer_types').subscribe(
        lookup_values => this.customer_types = <CustomerType[]>lookup_values,
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('Meh: ' + e);
    }

    this.switchHub();
  }

  switchHub(): void {
    if (!this.inHub) { this.inHub = new Hub(); }
    this.hub = Object.assign({}, this.inHub);  // Clone
    this.getVersionUpgrade(this.hub.hubid);
    this.hubService.getHubState(this.hub.hubid).subscribe(
      hubState => this.hubState = hubState,
      HubService.LogRefreshError,
    );
    if (this.hub.holiday) {
      this.heatingStateDescription = 'Holiday Mode';
    } else if (this.hub.heating) {
      switch (this.hub.heating) {
        case 4:
          this.heatingStateDescription = 'Holiday Mode';
          break;
        case 3:
          this.heatingStateDescription = 'On with Offset';
          break;
        case 2:
          this.heatingStateDescription = 'Boost';
          break;
        case 1:
          this.heatingStateDescription = 'On';
          break;
      }
      if (this.hub.heating < 4) {
        this.heatingStateDescription += ` with boiler ` + (this.hub.boiler ? 'ON' : 'OFF');
      }
    } else {
      this.heatingStateDescription = 'OFF';
    }
  }

  getVersionUpgrade(hubid: number): void {
    console.log('Getting Version Upgrade ' + hubid);
    if (!hubid) {
      return;
    }
    let upgradeURL = HubService.BaseURL + 'hub/' + hubid + '/upgrade';
    this.api.Get(upgradeURL)
      .subscribe(
        response => {
          this.upgradeVersion = response.data['version'];
        },
        e => {
          console.error('getVersionUpgrade error: ' + JSON.stringify(e, null, 2));
        },
      );
  }

  SameOrNewerThan(major: number, minor: number, patch: number): boolean {
    if (this.hub.major > major) { return true; }
    if (this.hub.major === major && this.hub.minor > minor) { return true; }
    return (this.hub.major === major && this.hub.minor === minor && this.hub.patch >= patch);
  }

  lastSeenClass(): string {
    let seen = Date.parse(this.hub.last_seen);
    let now = Date.now();
    if (seen > (now - 7200000)) { return 'seen_last_2'; }
    if (seen > (now - 28800000)) { return 'seen_last_8'; }
    return 'not_seen_recently';
  }

  firmwareVersionClass(): string {
    if (this.upgradeVersion) {
      {
        if (this.hub.major === 0 && this.hub.minor < 7) {
          return 'really_old_version';
        }
        return 'new_version_available';
      }
    }
    return 'up_to_date';
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName of Object.keys(changes)) {
      // console.log('Property ' + propName + ' changed');
      switch (propName) {
        case 'inHub':
          this.switchHub();
          break;
      }
    }
  }

  updateSmartTech(): void {
    this.hubService.setSmartTechFlags(this.hub.hubid, this.hubState.duty_cycle, this.hubState.time_shaving, this.hubState.peak_temp_suppression)
      .subscribe(() => this.editable = false);
  }

  edit(): void {
    this.editable = true;
  }

  cancel(): void {
    this.editable = false;
    this.switchHub();
  }
}
